import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { sortByOrder } from 'utils/collection-manipulation/array-sort-by';
import {
  defaultData,
  TBottomNavigation
} from 'utils/constants/app/BottomNavigationDefaultData';
import { casinoEnabled } from 'utils/constants/app/general';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { fetchMenuData } from 'utils/generic/fetch-menu-data';
import { getMenuJsonData } from 'store/selectors/app-data';

export const useBottomNavData = (
  callback?: (arg: boolean) => void
): Array<Record<string, string | number>> | Array<TBottomNavigation> => {
  const history = useHistory();
  const data = useSelector(getMenuJsonData);
  const currentPath = `${history.location.pathname}/`;
  const lang = SpringConfigs.CURRENT_LANGUAGE;
  let DATA: Record<string, any>[] = [];

  useEffect(() => {
    if (!data.length) {
      fetchMenuData(callback);
    } else {
      callback?.(false);
    }
  }, []);

  let currentCategory =
    data?.find((element: Record<string, any>) => {
      const path =
        typeof element.path !== 'string' && element.path
          ? element.path[lang]
            ? element.path[lang]
            : element.path.fallback
          : element.path;

      return currentPath?.includes(`/${path}/`);
    })?.categoryBottom || 'sport';

  if (currentCategory === 'esport' || currentCategory === 'racing') {
    currentCategory = 'sport';
  }

  if (data.length) {
    DATA = data.filter(section => {
      const shouldShowBetslip =
        section.type === 'betslip' &&
        (typeof SpringConfigs.SHOW_BETSLIP_IN_BOTTOM_NAV === 'boolean'
          ? SpringConfigs.SHOW_BETSLIP_IN_BOTTOM_NAV
          : section.categoryBottom === currentCategory &&
            section.badge &&
            !casinoEnabled);

      return shouldShowBetslip || (section.showBottomNav && !section.badge);
    });
    DATA = sortByOrder(DATA, 'orderBottomNav');
  }

  return DATA.length ? DATA : defaultData;
};
